/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: fafc9db00f76
 */

import * as z from "zod";

export type MessageResponse = { message: string };

export const MessageResponse$zodSchema: z.ZodType<MessageResponse> = z.object({
  message: z.string().describe("A human-readable status message."),
});
